import { createSelector } from 'reselect';
import Constants from './constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const loginIsSubmittingSelector = createSelector(stateSelector, (state) => state.isSubmitting);
const loginErrorSelector = createSelector(stateSelector, (state) => state.error);
const loginRequiresCaptchaSelector = createSelector(stateSelector, (state) => state.requiresCaptcha);
const loginSsoProvidersSelector = createSelector(stateSelector, (state) => state.ssoProviders);

const loginRequires2faSelector = createSelector(stateSelector, (state) => state.requires2fa);
const loginChallengeIdSelector = createSelector(stateSelector, (state) => state.challengeId);
const loginTwoFaEmailSelector = createSelector(stateSelector, (state) => state.twoFaEmail);
const loginTwoFaTriggersSelector = createSelector(stateSelector, (state) => state.twoFaTriggers);
const loginResendAvailableInSelector = createSelector(stateSelector, (state) => state.resendAvailableIn);
const loginResendNonceSelector = createSelector(stateSelector, (state) => state.resendNonce);
const loginTwoFaAttemptsRemainingSelector = createSelector(stateSelector, (state) => state.twoFaAttemptsRemaining);
const loginTwoFaErrorSelector = createSelector(stateSelector, (state) => state.twoFaError);
const loginTwoFaVerifyingSelector = createSelector(stateSelector, (state) => state.twoFaVerifying);
const loginTwoFaResendingSelector = createSelector(stateSelector, (state) => state.twoFaResending);

export const LoginSelectors = {
  loginIsSubmittingSelector,
  loginErrorSelector,
  loginRequiresCaptchaSelector,
  loginSsoProvidersSelector,
  loginRequires2faSelector,
  loginChallengeIdSelector,
  loginTwoFaEmailSelector,
  loginTwoFaTriggersSelector,
  loginResendAvailableInSelector,
  loginResendNonceSelector,
  loginTwoFaAttemptsRemainingSelector,
  loginTwoFaErrorSelector,
  loginTwoFaVerifyingSelector,
  loginTwoFaResendingSelector,
};
